<template>
    <component :is="tag">
        <slot
            :brief="brief"
            :step="step"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :isLoading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :errors="errors"
            :errorMessage="errorMessage"
            :uses-alternate-terms="usesAlternateTerms"
        />
    </component>
</template>

<script>
    import {NAME_CONTENT_AGREEMENT} from '../../../constants/activation-brief-steps';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import * as _ from 'lodash';

    export default {
        name:   'ActivationBriefAgreementsProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step(){
                return this.steps[NAME_CONTENT_AGREEMENT];
            },
            usesAlternateTerms(){
                return _.get(window.SERVER_DATA, 'alternate_terms_of_service', false);
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                    ]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>

<style scoped>

</style>
